export default {
  "LanguageSwitch.Locale": "Language",
}
